import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { BranchMaster } from 'app/masters/models/branch-master.model';
import { LocationService } from '../../location.service';

@Component({
  selector: 'app-search-country-master',
  templateUrl: './search-country-master.component.html',
  styleUrls: ['./search-country-master.component.scss']
})
export class SearchCountryMasterComponent implements OnInit {
  dataSource = new MatTableDataSource<BranchMaster>();
  selection = new SelectionModel<any>(true, []);
  displayedColumns: string[] = ['countryName', 'countryCode', 'isActive' , 'MobileLen' , 'PinCodeLen'];

  constructor(public dialog: MatDialog, public locationService: LocationService,public dialogRef: MatDialogRef<SearchCountryMasterComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.getCountryList();
    this.locationService.selecteCountryData = null;
  }

  /** Get Country list API */
  getCountryList() {
    this.locationService.getCountry().subscribe(data => {
      this.dataSource.data = data
      this.dataSource.filterPredicate = (data: any, filter: string) => {
        const searchTerm = filter.trim().toLowerCase();

  return (
    (data.countryName && data.countryName.toLowerCase().includes(searchTerm))
    // (data.countryCode && data.countryCode.toLowerCase().includes(searchTerm)) ||
    // (data.mobLength && data.mobLength.toString().includes(searchTerm)) ||
    // (data.pinCodeLength && data.pinCodeLength.toString().includes(searchTerm))
  );
};

    });
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  selectRow(row) {
    this.selection.toggle(row);
    this.locationService.selecteCountryData = row;
    this.dialogRef.close();
  }

  /** Close popup */
  closedialog() {
    this.dialogRef.close();
  }
}
